export default "__VITE_ASSET__BDmCNpDO__"